import { css } from 'styled-components';
export var applyNoSelect = function applyNoSelect() {
  return css(["user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0);"]);
};